export interface TableFilterStyles {
  tableFiltersStyleClass: string;
  filterWrapperStyleClass: string;
  filterStyleClass: string;
  wrapperFiltersStyleClass?: string;
}
